// extracted by mini-css-extract-plugin
module.exports = {"SimpleSearchContainer":"DealSearch_SimpleSearchContainer__NSyEF","SearchDetailContainer":"DealSearch_SearchDetailContainer__3cb4I"};